"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("rxjs/add/operator/toPromise");
var Observable_1 = require("rxjs/Observable");
var idm_application_properties_service_client_js_1 = require("@synisys/idm-application-properties-service-client-js");
var idm_authentication_client_js_1 = require("@synisys/idm-authentication-client-js");
var core_1 = require("@angular/core");
require("rxjs/add/observable/combineLatest");
require("rxjs/add/observable/zip");
var idm_crosscutting_concepts_frontend_1 = require("@synisys/idm-crosscutting-concepts-frontend");
var idm_message_language_service_client_js_1 = require("@synisys/idm-message-language-service-client-js");
var form_model_1 = require("./form.model");
/**
 *
 * @author Anania.Mikaelyan
 */
var FormManagementService = /** @class */ (function () {
    function FormManagementService(serviceUri, http, applicationPropertiesService, languageService) {
        this.serviceUri = serviceUri;
        this.http = http;
        this.applicationPropertiesService = applicationPropertiesService;
        this.languageService = languageService;
        this.serviceUri$ = Observable_1.Observable.from(this.applicationPropertiesService.getProperty(this.serviceUri));
        this.languages$ = this.languageService.getAvailableLanguages();
    }
    FormManagementService.deserializeServerResponse = function (data, languages) {
        var items = [];
        var jsonData = data.json ? data.json() : data; //done for loading json from file as well
        jsonData.forEach(function (jsonItem) {
            items.push(FormManagementService.deserializeForm(jsonItem, languages));
        });
        return items;
    };
    FormManagementService.deserializeForm = function (jsonItem, languages) {
        return new form_model_1.Form(jsonItem.id, jsonItem.formSystemName, jsonItem.categorySystemName, jsonItem.typeId, FormManagementService.deserializeMultilingualString(jsonItem.name, languages), FormManagementService.deserializeMultilingualString(jsonItem.description, languages), jsonItem.data, jsonItem.subCategorySystemName, jsonItem.formEntityTypeId);
    };
    /**
     * Deserializes the multilingual string field value.
     * @param {any} jsonData - The array of multilingual values according to application languages.
     * @param {Array<Language>} languages - The array of available languages in the system.
     * @returns {MultilingualString} the multilingual string object filled with the passed data
     */
    /**
         * Deserializes the multilingual string field value.
         * @param {any} jsonData - The array of multilingual values according to application languages.
         * @param {Array<Language>} languages - The array of available languages in the system.
         * @returns {MultilingualString} the multilingual string object filled with the passed data
         */
    FormManagementService.deserializeMultilingualString = /**
         * Deserializes the multilingual string field value.
         * @param {any} jsonData - The array of multilingual values according to application languages.
         * @param {Array<Language>} languages - The array of available languages in the system.
         * @returns {MultilingualString} the multilingual string object filled with the passed data
         */
    function (jsonData, languages) {
        var multilingualStringBuilder = idm_crosscutting_concepts_frontend_1.MultilingualString.newBuilder();
        languages.forEach(function (language) {
            var languageId = language.getId();
            multilingualStringBuilder.withValueForLanguage(languageId, (jsonData
                && jsonData[languageId] !== undefined
                && jsonData[languageId] !== null) ? jsonData[languageId] : null);
        });
        return multilingualStringBuilder.build();
    };
    FormManagementService.decorators = [
        { type: core_1.Injectable },
    ];
    /** @nocollapse */
    FormManagementService.ctorParameters = function () { return [
        null,
        { type: idm_authentication_client_js_1.HttpClientWrapper, },
        { type: idm_application_properties_service_client_js_1.ApplicationPropertiesService, },
        { type: idm_message_language_service_client_js_1.LanguageService, },
    ]; };
    return FormManagementService;
}());
exports.FormManagementService = FormManagementService;
exports.FORM_MANAGEMENT_SERVICE = new core_1.InjectionToken("Provide your implementation of FormManagementService");
//# sourceMappingURL=form-management.service.js.map